const positive = (value) => Number.isSafeInteger(Number(value)) && Number(value) > 0;

export const selectionKey = (selection) => `${selection?.type || 'all'}:${selection?.id || ''}`;
export const selectionParams = (selection) => ({
  selectionType: selection?.type || 'all',
  ...(selection?.type === 'shop' ? { scopeShopId: selection.id } : {}),
  ...(selection?.type === 'mso' ? { msoId: selection.id } : {}),
});
export const selectionTitle = (selection) => {
  if (selection?.type === 'mso') {
    const count = selection.locationCount;
    return `${selection.name || `MSO #${selection.id}`}${Number.isInteger(count) ? ` · ${count} location${count === 1 ? '' : 's'}` : ''}`;
  }
  if (selection?.type === 'shop') return `${selection.name || 'Shop'} · #${selection.id}`;
  return selection?.type === 'invalid' ? 'Invalid account selection' : 'Global · All accounts';
};

export function readSelection(url, fallback = { type: 'all' }) {
  if (!url.searchParams.has('admin_scope')) return fallback;
  const type = url.searchParams.get('admin_scope');
  const id = Number(url.searchParams.get('admin_scope_id'));
  if (type === 'all') return { type: 'all', name: 'All accounts' };
  if (!['shop', 'mso'].includes(type) || !positive(id)) return { type: 'invalid' };
  return { type, id };
}

export function writeSelection(url, selection) {
  url.searchParams.set('admin_scope', selection.type);
  if (selection.type === 'shop' || selection.type === 'mso')
    url.searchParams.set('admin_scope_id', selection.id);
  else url.searchParams.delete('admin_scope_id');
  return url;
}

export function assertSelectionResponse(response, selection) {
  const expected = selectionParams(selection);
  // New MSO services must acknowledge the filter. An older endpoint that ignores
  // msoId must never render its unrestricted portfolio under an MSO heading.
  if (['mso', 'shop'].includes(selection?.type) || response?.scope?.selectionType) {
    if (
      !response?.scope ||
      Object.entries(expected).some(([key, value]) => String(response.scope[key]) !== String(value))
    )
      throw new Error('The response does not match the selected shops. Refresh and try again.');
  }
}

export const SHARED_ADMIN_SECTIONS = new Set([
  'subscriptions.plans',
  'subscriptions.discounts',
  'marketing.pricing',
  'integrations.catalog',
]);
